// Session topics a learner can optionally attach to a call request, so the
// guide knows what they want to work on before accepting. Pure logic, no React:
// LobbyContext sanitizes untrusted wire input with sanitizeTopic() too.

export const SESSION_TOPICS = [
  'Alphabet',
  'Animals',
  'Colors',
  'Basic signs',
  'Deaf culture',
  'Test preparation',
  'Conversation practice',
] as const;

export const OTHER_TOPIC = 'Other';

// sanitizeTopic and TOPIC_MAX_LENGTH live in @aslgo/shared (the backend uses
// them too); re-exported here so existing importers keep their path.
export { sanitizeTopic, TOPIC_MAX_LENGTH } from '@aslgo/shared';
import { sanitizeTopic } from '@aslgo/shared';

/** The single display string an invite carries, or undefined for "no topic".
 *  "Other" with a blank box is deliberately the same as no topic — the learner
 *  is never blocked, and no empty chip reaches the guide. */
export function resolveTopic(choice: string | null, other: string): string | undefined {
  if (choice === null) return undefined;
  if (choice === OTHER_TOPIC) return sanitizeTopic(other);
  return sanitizeTopic(choice);
}
